import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import { BlockLink, LinkProps, Flex, Text, Icon } from '@qga/roo-ui/components';
import { Link as RouterLink } from 'react-router-dom';
import { FC } from 'react';

interface Props extends Partial<LinkProps> {
  label: string;
  url: string;
  onClick?: () => void;
  external?: boolean;
}

const Link = styled(BlockLink)`
  margin-bottom: ${themeGet('space.4')};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const ItemLink: FC<Props> = ({ label, url, external, ...props }) => (
  <Link as={external ? 'a' : RouterLink} to={url} href={url} {...props}>
    <Flex justifyContent="space-between" fontSize="lg">
      <Text fontSize="lg">{label}</Text>
      <Icon name="arrowForward" color="red" />
    </Flex>
  </Link>
);

export default ItemLink;
